/**
 * Payment Service
 * Handles Stripe payment integration for credit purchases and subscriptions
 */

import { apiClient } from './api.client';

export type PurchaseType = 'starter' | 'professional' | 'enterprise';

export interface CreateCheckoutSessionRequest {
  userId: string;
  purchaseType: PurchaseType;
  successUrl?: string;
  cancelUrl?: string;
}

export interface CheckoutSessionResponse {
  sessionId: string;
  url: string;
}

/**
 * Create a Stripe checkout session for purchasing credits or subscribing
 */
export const createCheckoutSession = async (
  request: CreateCheckoutSessionRequest
): Promise<CheckoutSessionResponse> => {
  try {
    const response = await apiClient.post<CheckoutSessionResponse>(
      '/api/users/create-checkout-session',
      request
    );
    return response;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw new Error('Failed to create checkout session');
  }
};

/**
 * Cancel a user's subscription
 */
export const cancelSubscription = async (userId: string): Promise<void> => {
  try {
    await apiClient.post(`/api/users/${userId}/cancel-subscription`);
  } catch (error) {
    console.error('Error canceling subscription:', error);
    throw new Error('Failed to cancel subscription');
  }
};

/**
 * Get purchase details by type
 */
export const getPurchaseDetails = (purchaseType: PurchaseType) => {
  switch (purchaseType) {
    case 'starter':
      return {
        name: 'Starter',
        price: '$10',
        credits: 1,
        description: 'Perfect for one contract!',
      };
    case 'professional':
      return {
        name: 'Professional',
        price: '$99',
        credits: 12,
        description: 'If you need to analyze or generate multiple contracts!',
      };
    case 'enterprise':
      return {
        name: 'Enterprise',
        price: '$200/Mo',
        credits: 'Unlimited',
        description: 'For unlimited usage (good for large companies)',
      };
    default:
      throw new Error('Invalid purchase type');
  }
};

